import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items, testIdPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid={`${testIdPrefix}-accordion`} className="border-y border-[#2a1a3a]">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="accordion-item">
            <button
              data-testid={`${testIdPrefix}-toggle-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full px-1 md:px-2 py-6 md:py-7 flex items-center justify-between text-left gap-6"
            >
              <span className="font-display text-base md:text-lg tracking-tight leading-snug">
                {it.q}
              </span>
              <span className="shrink-0 w-7 h-7 border border-[#2a1a3a] flex items-center justify-center text-[#ff1493]">
                {isOpen ? <Minus size={13} strokeWidth={1.5} /> : <Plus size={13} strokeWidth={1.5} />}
              </span>
            </button>
            {isOpen && (
              <div className="px-1 md:px-2 pb-7 pr-10 md:pr-16 max-w-3xl font-body leading-[1.7] text-[15px] md:text-[16px] text-[#c4b6d6]">
                {it.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
